import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "carousel-control-prev" }
const _hoisted_2 = ["onClick", "onKeydown"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Previous slide", -1)
const _hoisted_4 = { class: "carousel-control-next" }
const _hoisted_5 = ["onClick", "onKeydown"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next slide", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_lazy = _resolveComponent("v-lazy")!

  return (_openBlock(), _createBlock(_component_v_lazy, { class: "vehicleImageCarousel" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_carousel, {
        ref: "vehicleImageCarousel",
        height: "auto",
        "show-arrows": "hover",
        "hide-delimiter-background": true
      }, {
        prev: _withCtx(({ props }) => [
          _createElementVNode("span", _hoisted_1, [
            _createElementVNode("span", {
              class: "carousel-control-prev-icon",
              onClick: _withModifiers(props.onClick, ["prevent","stop"]),
              onKeydown: _withKeys(_withModifiers(props.onClick, ["prevent","stop"]), ["enter"]),
              role: "button",
              tabindex: "0"
            }, null, 40, _hoisted_2),
            _hoisted_3
          ])
        ]),
        next: _withCtx(({ props }) => [
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("span", {
              class: "carousel-control-next-icon",
              onClick: _withModifiers(props.onClick, ["prevent","stop"]),
              onKeydown: _withKeys(_withModifiers(props.onClick, ["prevent","stop"]), ["enter"]),
              role: "button",
              tabindex: "0"
            }, null, 40, _hoisted_5),
            _hoisted_6
          ])
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageList, (image, index) => {
            return (_openBlock(), _createBlock(_component_v_carousel_item, {
              "aspect-ratio": 4 / 3,
              key: index,
              src: image as string,
              alt: _ctx.imageAltText,
              width: "100%",
              height: "auto",
              onClick: _withModifiers(_ctx.imageClick, ["prevent","stop"])
            }, null, 8, ["src", "alt", "onClick"]))
          }), 128)),
          _createVNode(_component_v_carousel_item, {
            class: "black-blur-image",
            src: (_ctx.lowRezImage as string) || (_ctx.imageList?.[0] as string),
            alt: _ctx.imageAltText,
            width: "400",
            height: "300"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, { class: "secondary-light" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('See car details')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["src", "alt"])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}